<script lang="ts" setup>
	defineProps<{
		list: string[]
		liClass?: ClassContext
	}>()
</script>

<template>
	<ul>
		<li
			v-for="(item, index) in list"
			:key="index"
			class="item-start flex gap-x-2 py-2.5 leading-[28px] tracking-wide"
		>
			<div class="mt-1.5 h-[7px] w-[7px] flex-none rounded-full bg-purple-200" />
			<div class="text-sm font-medium text-gray-600" v-html="item" />
		</li>
	</ul>
</template>
